import { ProductLinkerRender } from "../../post/linker/product-linker-render";
import type { UserModalFavorite, UserModalFollower, UserModalFollowing, UserModalPost } from "../modal/user-modal-api";
import { UserFollowRender } from "../follow/user-follow-render";
import { Roles } from "../../constants/roles";
import { UserProfileTabsForm } from "./user-profile-tabs-form";
import commonUtil from "../../util/common-utils";
import { toPositiveIntOrNull } from "../../util/id-utils";

const userProfileTabsRenderForm = new UserProfileTabsForm(document.createElement("div"));

type UserProfileProductCard = UserModalPost | UserModalFavorite;

export class UserProfileTabsRender {
    public static renderRankingStyleProductRows(
        products: UserProfileProductCard[],
        options: { favoritesMode?: boolean } = {},
    ): string {
        const favoritesMode = options?.favoritesMode === true;
        return products
            .map((item) => {
                const tmp = document.createElement("div");
                ProductLinkerRender.renderProduct(tmp, item, { targetBlank: false });
                const card = userProfileTabsRenderForm.getRenderedProductCard(tmp);
                if (card instanceof HTMLElement) {
                    card.classList.add("card");

                    if (favoritesMode) {
                        card.classList.add("user-favorite-card");

                        const productId = toPositiveIntOrNull(item?.product_id ?? card.dataset.productId);
                        if (productId !== null) {
                            card.dataset.favoriteProductId = String(productId);
                        }
                        card.dataset.role = Roles.USER_PROFILE_FAVORITE_CARD;
                    }
                }
                const cardHtml = tmp.innerHTML.trim();
                if (!cardHtml) return "";
                return `<div class="rankings-monthly__rank-row" data-role="${Roles.USER_PROFILE_TAB_ROW}">${cardHtml}</div>`;
            })
            .filter(Boolean)
            .join("");
    }

    public static renderUserRows(
        users: Array<UserModalFollower | UserModalFollowing>,
        options: { followingsMode?: boolean } = {},
    ): string {
        const followingsMode = options?.followingsMode === true;
        return users
            .map((item) => UserFollowRender.renderUserCardSlide(item, { followingsMode }))
            .filter(Boolean)
            .join("");
    }

    public static renderLoading(list: HTMLElement): void {
        list.innerHTML = `
            <div class="loading-content user-profile-tab-loading" aria-live="polite">
                <div class="spinner"></div>
                <div class="loading-text"></div>
            </div>
        `;
    }

    public static renderWithFallback(list: HTMLElement, html: string, fallback: string): void {
        list.innerHTML = html || fallback;
    }

    public static renderLoadError(list: HTMLElement): void {
        const safeText = commonUtil.escapeHtml("การโหลดล้มเหลว");
        list.innerHTML = `
            <div class="text-muted" data-translate="load_failed">
                ${safeText}
            </div>
        `;
    }

    public static applyActiveTab(
        layoutRoot: HTMLElement,
        tabsRoot: HTMLElement,
        buttons: Element[],
        statTriggers: Element[],
        tab: string,
    ): void {
        layoutRoot.setAttribute("data-active-tab", tab);
        tabsRoot.setAttribute("data-active-tab", tab);

        buttons.forEach((button) => {
            if (!(button instanceof HTMLElement)) return;
            const isActive = button.dataset.tab === tab;
            button.classList.toggle("is-active", isActive);
        });

        statTriggers.forEach((trigger) => {
            if (!(trigger instanceof HTMLElement)) return;
            const isActive = trigger.dataset.tab === tab;
            trigger.classList.toggle("is-active", isActive);
        });
    }
}
